// Keep API requests same-origin in local development and production.
// Vue dev server proxies /api to Django; nginx does the same on the server.
const BASE = ''

export function apiUrl(path) {
  const [pathname, query = ''] = path.split('?')
  return `${BASE}/api/${pathname.replace(/\/$/, '')}/${query ? `?${query}` : ''}`
}

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('writing-demo-token')
  const headers = {
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  }
  return fetch(apiUrl(path), {
    credentials: 'include',
    ...options,
    headers,
  })
}
